export default [
  {
    path: "/time-off-list",
    name: "timeOffList",
    component: () => import("@parent/views/base/time-off/list.vue"),
  },
  {
    path: "/ask-time-off",
    name: "asktimeOff",
    component: () => import("@parent/views/base/time-off/ask.vue"),
  },
  {
    path: "/time-off-details/:id",
    name: "timeoffDetails",
    component: () => import("@parent/views/base/time-off/details.vue"),
  },

];
